import React, { useEffect } from "react";
import Groups from "components/groups";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ga4 from "react-ga4";

const GroupsPage = () => {
  const { t } = useTranslation();
  const { state } = useLocation();

  const selectedGroup = state?.category;

  useEffect(() => {
    ga4.event({
      category: "app-interaction",
      action: "groups-page-view",
      page_name: "Grupos Farmacológicos",
    });
  }, []);

  return (
    <>
      <h2 className="m-0 ms-lg-4 mb-4 text-start">{t("auto.gruposFarmacologicos", "Grupos Farmacológicos")}</h2>
      <Groups select={selectedGroup} />
    </>
  );
};

export default GroupsPage;
